import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import Project from 'src/entities/Project';
import Investment from 'src/entities/Investment';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import ResultPageComponent from 'src/modules/commons/result-page/ResultPage.Component';

interface StateProps {
  project?: Project;
}

interface DispatchProps {
}

interface Props extends StateProps, DispatchProps {
  investment: Investment;

  setInvestment(investment: Investment, step: string): void;
}

class WritingContractsContainer extends React.Component<Props> {

  public componentWillMount(): void {
    if ((this.props.project) && (this.props.project.syndicateAgreement) && (this.props.project.stakeholderAgreement)) {
      this.handleConfirmContracts();
    }
  }

  public componentWillReceiveProps(newProps: Props) {
    if ((newProps.project) && (newProps.project.syndicateAgreement) && (newProps.project.stakeholderAgreement)) {
      this.handleConfirmContracts();
    }
  }

  public render(): React.ReactNode {
    if (!this.props.project) {
      return <LoadingContainer/>;
    }

    return (
      <ResultPageComponent
        title={'Gracias por confirmar sus datos como inversor y el importe comprometido en ' +
        this.props.project.company.name}
        message={'Ahora estamos trabajando en redactar toda la documentación legal.\n' +
        'En cuanto la tengamos disponible te notificaremos para que procedas a la revisión de la misma.'}
        success={true}
      />
    );
  }

  private handleConfirmContracts(): void {
    const investment: Investment = {
      ...this.props.investment!,
      status: 'Reviewing Contracts',
    };
    this.props.setInvestment(investment, investment.status!);
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  project: state.getProject.project
});

export default connect(mapStateToProps, mapDispatchToProps)(WritingContractsContainer);



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/writing-contracts/WritingContracts.container.tsx